/**
 * sale basket line Vue component
 * need include rest.client, citrus.vuex.store
 * @package citrus.vue.basket.line
 */
import {Vue} from "ui.vue";

let BasketLine = {
	name: 'BasketLine',
	store: BX.Citrus.Vuex.store,
	mixins: [BX.Citrus.Vue.Component.FormatMixin],
	data: function () {
		return {
			params: {
				SHOW_PRODUCTS: 'N',
				SHOW_IMAGE: 'N',
				SHOW_PRICE: 'N',
				SHOW_TOTAL_PRICE: 'Y',
				PATH_TO_BASKET: '/personal/cart/',
				SHOW_NUM_PRODUCTS: 'Y',
				SHOW_EMPTY_VALUES: 'N',
				ORDER_MAKE_MINUTES_QUANTITY_TRACE: 0
			},
			result: {
				items: [],
				num_products: 0,
				total_price: "",
				disable_use_basket: false,
			},
			siteId: "",
			ajaxPath: "",
			templateName: "",
			opened: false,
			loading: false,
			cutlery: [],
		};
	},
	created: function () {
		document.addEventListener('click', this.clickOutside);
		this.$on('hook:beforeDestroy', () => document.removeEventListener('click', this.clickOutside));

		BX.addCustomEvent("OnBasketChange", this.refresh);
		Vue.event.$on("Citrus.Component.Basket:update", this.refresh);

		this.$store.dispatch('basket/setOrderMakeMinutes', this.params.ORDER_MAKE_MINUTES_QUANTITY_TRACE);
	},
	beforeDestroy() {
		BX.removeCustomEvent("OnBasketChange", this.refresh);
		Vue.event.$off("Citrus.Component.Basket:update", this.refresh);
	},
	mounted: function () {
		BX.onCustomEvent("Citrus.Component.Basket:init", [this]);
	},
	computed: {
		loc() {
			return Vue.getFilteredPhrases("TSB1_");
		},
		count() {
			return this.result.num_products > 99 ? "99+" : this.result.num_products;
		},
		totalFormatted() {
			return this.formatPrice(this.result.total_price);
		},
		cutleryList() {
			let cutleryList = [];

			for (let i = 0; i < this.cutlery.length; i++) {

				if (this.result.items.find(el => el['product_id'] === this.cutlery[i]['product_id'])) {
					continue;
				}

				cutleryList.push(this.cutlery[i]);
			}

			return cutleryList;
		},
		orderMakeMinutes() {
			return this.$store.getters['basket/setOrderMakeMinutes'];
		}
	},
	methods: {
		clickOutside(e) {
			if (!this.$el.contains(e.target)) {
				this.opened = false;
			}
		},
		openCard() {
			this.opened = true;
			document.querySelector('body').classList.add("vue-modal-open");

			this.$gtag.event(this.$metrika.Goal.BASKET_CLICK);
			this.$metrika.reachGoal(this.$metrika.Goal.BASKET_CLICK);
		},
		setResult: function (result) {
			this.result = result;
			let productToBasket = {};
			for (let key in this.result.items) {
				let item = this.result.items[key];
				productToBasket[item.product_id] = item.quantity;
				Vue.event.$emit("Citrus.Vue.Product:addedToBasket:" + item.product_id, {
					basketItem: item.id,
					name: "sale-basket-line"
				});
			}

			this.$store.dispatch('basket/load', productToBasket);
			this.$store.dispatch('basket/setOrderStock', this.result.stock);
		},
		getDeliveryTimeCookie() {
			return BX.getCookie("savedDeliveryTime") ? JSON.parse(BX.getCookie("savedDeliveryTime")) : null;
		},
		initViewStock: function () {
			let savedDeliveryTime = this.getDeliveryTimeCookie();

			if (savedDeliveryTime === null || (savedDeliveryTime.DELIVERY_TIME === '' && savedDeliveryTime.PICKUP_TIME === '')) {
				this.$store.dispatch('basket/toggleViewStock', true);
				return;
			}

			if (savedDeliveryTime.DELIVERY_TIME === 'now') {
				this.$store.dispatch('basket/toggleViewStock', true);
				return;
			}

			if (savedDeliveryTime.PICKUP_TIME !== '') {

				let cookieDate = savedDeliveryTime.PICKUP_TIME;
				let chosenDateArray = cookieDate.split(' ');
				let chosenDate = chosenDateArray[0].split('.').reverse().join('-');
				let formattedChosenDate = chosenDate + 'T' + chosenDateArray[1];
				formattedChosenDate = new Date(formattedChosenDate);
				formattedChosenDate.setMinutes(formattedChosenDate.getMinutes() + this.orderMakeMinutes);

				let availableDate = this.result.stock.min_date.split('.').reverse().join('-');
				let formattedAvailableDate = availableDate + `T${this.result.stock.min_time}`;

				let compareDate = formattedChosenDate.getTime() < new Date(formattedAvailableDate).getTime();
				this.$store.dispatch('basket/toggleViewStock', compareDate);
			}
		},
		refresh: function () {
			if (this.loading)
				return;

			this.loading = true;

			BX.ajax({
				url: this.ajaxPath,
				method: 'POST',
				dataType: 'json',
				timeout: 30,
				data: BX.ajax.prepareData({
					sessid: BX.bitrix_sessid(),
					siteId: this.siteId,
					templateName: this.templateName,
					arParams: this.params,
				}),
				onsuccess: (response) => {
					this.loading = false;
					this.result = response;
				},
				onfailure: (error) => {
					this.loading = false;
					console.error(error);
				}
			});
		},
	},
	watch: {
		opened: function () {
		  if(this.opened) {
			document.querySelector('body').classList.add("vue-modal-open");
		  } else {
			document.querySelector('body').classList.remove("vue-modal-open");
		  }
		}
	}
};

export {BasketLine};
export default {BasketLine};
